import api from './client'
import axios from 'axios'
import { getAdminAuthHeader } from '../utils/auth'
import { downloadBlobResponse } from '../utils/fileExport'

function authCfg(extra = {}) {
  return {
    ...extra,
    headers: { ...(extra.headers || {}), ...getAdminAuthHeader() }
  }
}

export async function fetchExpiryItems({ keyword = '', status = '', page = 1, pageSize = 20 } = {}) {
  return api.get('/admin/expiry/items', {
    params: { keyword, status, page, pageSize }
  })
}

export async function getExpiryItem(id) {
  return api.get(`/admin/expiry/items/${id}`)
}

export async function createExpiryItem(payload) {
  return api.post('/admin/expiry/items', payload)
}

export async function updateExpiryItem(id, payload) {
  return api.put(`/admin/expiry/items/${id}`, payload)
}

export async function deleteExpiryItem(id) {
  return api.delete(`/admin/expiry/items/${id}`)
}

export async function batchDeleteExpiryItems(ids) {
  return api.post('/admin/expiry/items/batch-delete', { ids })
}

export async function fetchExpiryStats() {
  return api.get('/admin/expiry/stats')
}

export async function refreshExpiryStatuses() {
  return api.post('/admin/expiry/refresh-statuses')
}

export async function exportExpiryItems({ keyword = '', status = '' } = {}) {
  const response = await axios.get('/api/admin/expiry/export', authCfg({
    params: { keyword, status },
    responseType: 'blob'
  }))
  downloadBlobResponse(response, `效期管理_${new Date().toISOString().slice(0, 10)}`)
}

export async function downloadExpiryTemplate() {
  const response = await axios.get('/api/admin/expiry/template', authCfg({
    responseType: 'blob'
  }))
  downloadBlobResponse(response, '效期管理导入模板')
}

export async function printCatenLabel(content) {
  return api.post('/admin/print/caten/label', { content })
}

export async function importExpiryItems(formData) {
  return api.post('/admin/expiry/import', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export async function sendTestReminder(id) {
  return api.post(`/admin/expiry/items/${id}/test-reminder`)
}